import { useEffect } from 'react'
import { Toasts } from '../../components/toaster/Toast'
import React from 'react'

export const upgradeToastCopy = (count: number) =>
    `${count} ${count === 1 ? 'Segment' : 'Segments'} created. Your original ${
        count === 1 ? 'recipe is' : 'recipes are'
    } switched off.`

const parseUpgradedCount = (value: string | null): number | null => {
    if (value === null || !/^[1-9]\d*$/.test(value)) {
        return null
    }

    const count = Number(value)
    return Number.isSafeInteger(count) ? count : null
}

export const useUpgradeToast = () => {
    useEffect(() => {
        const url = new URL(window.location.href)
        const count = parseUpgradedCount(url.searchParams.get('upgraded'))

        if (count === null) {
            return
        }

        Toasts.success(
            React.createElement(
                React.Fragment,
                null,
                upgradeToastCopy(count),
                ' ',
                url.pathname !== '/segments'
                    ? React.createElement('a', { className: 'underline', href: '/segments' }, 'View Segments')
                    : null,
            ),
        )
        url.searchParams.delete('upgraded')
        window.history.replaceState(
            window.history.state,
            '',
            `${url.pathname}${url.search}${url.hash}`,
        )
    }, [])
}
